import { render, staticRenderFns } from "./listSkills.vue?vue&type=template&id=0dc5707a&scoped=true&"
import script from "./listSkills.vue?vue&type=script&lang=js&"
export * from "./listSkills.vue?vue&type=script&lang=js&"
import style0 from "./listSkills.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./listSkills.vue?vue&type=style&index=1&id=0dc5707a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc5707a",
  null
  
)

export default component.exports